import { createActions, createReducer } from 'reduxsauce'

import ConsultaDiariasPassagensService from '../../servicos/ConsultaDiariasPassagensService'

/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
    buscaConsultaDiariasPassagensInicio: [],
    buscaConsultaDiariasPassagensErro: ['erro'],
    buscaConsultaDiariasPassagensSucesso: ['consultaDiariasPassagens'],
    limpar: [],
    setConsultaDiariasPassagensEstadoDT: ['estado'],
})

const INITIAL_STATE = {
    carregando: false,
    erro: null,
    lista: [],
    dataSincronizacaoDados: null,
    estadoDT: {},
}

// Ação para busca completa
Creators.buscaConsultaDiariasPassagens = filtro => {
    return dispatch => {
        dispatch(Creators.buscaConsultaDiariasPassagensInicio())
        let serv = new ConsultaDiariasPassagensService()
        return serv
            .consultar(filtro)
            .then(response => dispatch(Creators.buscaConsultaDiariasPassagensSucesso(response.data)))
            .catch(error => dispatch(Creators.buscaConsultaDiariasPassagensErro(error)))
    }
}

const buscaConsultaDiariasPassagensInicio = (state = INITIAL_STATE, action) => ({ ...state, carregando: true, erro: null })

const buscaConsultaDiariasPassagensErro = (state = INITIAL_STATE, action) => ({ ...state, erro: action.erro, carregando: false })

const buscaConsultaDiariasPassagensSucesso = (state = INITIAL_STATE, action) => {
    return {
        ...state,
        lista: action.consultaDiariasPassagens.resultado,
        dataSincronizacaoDados: action.consultaDiariasPassagens.dataSincronizacaoDados,
        fonte: action.consultaDiariasPassagens.fonte,
        carregando: false,
    }
}

const limpar = (state = INITIAL_STATE, action) => {
    return INITIAL_STATE
}

const setConsultaDiariasPassagensEstadoDT = (state = INITIAL_STATE, action) => {
    return { ...state, estadoDT: action.estado }
}

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
    [Types.BUSCA_CONSULTA_DIARIAS_PASSAGENS_INICIO]: buscaConsultaDiariasPassagensInicio,
    [Types.BUSCA_CONSULTA_DIARIAS_PASSAGENS_ERRO]: buscaConsultaDiariasPassagensErro,
    [Types.BUSCA_CONSULTA_DIARIAS_PASSAGENS_SUCESSO]: buscaConsultaDiariasPassagensSucesso,
    [Types.LIMPAR]: limpar,
    [Types.SET_CONSULTA_DIARIAS_PASSAGENS_ESTADO_DT]: setConsultaDiariasPassagensEstadoDT,
})
